module.exports = "<div class=orders-not-received ng-cloak> <md-card> <rkc-toolbarheader toolbarheader-definition=c.toolbarheaderDefinition></rkc-toolbarheader> <rkc-searchform search-definition=c.searchDefinition></rkc-searchform> </md-card> <md-card> <rkc-table table-content=c.searchResult table-definition=c.tableDefinition></rkc-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/ordersNotReceived/ordersNotReceived.html
 ** module id = 521
 ** module chunks = 0
 **/